import React, { useEffect, useState } from 'react';
import { api } from "../services";
import '../index.css'
import {useLocalization} from "../context/localization";
import {useNavigate} from "react-router-dom";

const Logo = () => {
    const [logoUrl, setLogoUrl] = useState('');
    const { language } = useLocalization();
    const navigate = useNavigate();
    

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await api.general.getLogos(language);
                const logoPath = res?.data.data.attributes?.logo.data[0].attributes.url;
                setLogoUrl(logoPath);
            } catch (error) {
                console.error('Error fetching home content:', error);
            }
        };
        fetchData();
    }, []);

    return (
            <img style={{ cursor: 'pointer' }}  onClick={()=> navigate('/')} className={"logo-custom"} src={logoUrl} alt="Logo"/>
    );
};

export default Logo;
